<div class="form-field">
    <div class="input-wrapper" [class.error]="hasErrors" [class.valid]="isValid">
    <input
        id="email-input"
        type="email"
        [value]="value"
        (input)="onInput($event)"
        (blur)="onBlur()"
        maxlength="255"
        placeholder="contact@example.com"
        class="form-control"
        [class.is-valid]="isValid"
        [class.is-invalid]="hasErrors"
    />
    </div>
    @if(hasErrors && touched) {
        <div class="error-messages">
            @for(error of getErrors(); track $index) {
                <p class="text-danger text-start pt-1 mb-0">{{ error }}</p>
            }
        </div>
    }
</div>